export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-primary-500/10 via-accent-500/8 to-primary-500/5 border border-primary-500/20 rounded-2xl p-8 md:p-10">
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="flex-1 text-center md:text-left">
                <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/25 mb-4">
                  <i className="ri-smartphone-line text-primary-400 text-sm"></i>
                  <span className="text-primary-300 text-xs font-medium">多端观影</span>
                </span>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                  随时随地 · 追剧不停
                </h2>
                <p className="text-foreground-500 text-sm leading-relaxed mb-5 max-w-md">
                  6080新视觉影院全面适配手机、平板与电脑端，无需下载任何客户端。打开浏览器输入网址即可畅享高清流畅的电视剧全集免费在线观看体验，多线加速确保移动网络同样秒开不卡。
                </p>
                <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
                  <div className="flex items-center gap-2 px-4 py-2.5 bg-background-50 border border-background-200/60 rounded-lg">
                    <i className="ri-computer-line text-primary-500 text-lg"></i>
                    <span className="text-foreground-700 text-sm font-medium">电脑端</span>
                  </div>
                  <div className="flex items-center gap-2 px-4 py-2.5 bg-background-50 border border-background-200/60 rounded-lg">
                    <i className="ri-smartphone-line text-primary-500 text-lg"></i>
                    <span className="text-foreground-700 text-sm font-medium">手机端</span>
                  </div>
                  <div className="flex items-center gap-2 px-4 py-2.5 bg-background-50 border border-background-200/60 rounded-lg">
                    <i className="ri-tablet-line text-primary-500 text-lg"></i>
                    <span className="text-foreground-700 text-sm font-medium">平板端</span>
                  </div>
                </div>
              </div>
              <div className="flex-shrink-0">
                <div className="relative w-52 h-80">
                  <div className="absolute inset-0 bg-gradient-to-br from-primary-500/20 to-accent-500/10 rounded-2xl blur-lg"></div>
                  <div className="relative rounded-2xl border-2 border-background-300/60 overflow-hidden bg-background-100">
                    <div className="h-8 bg-background-200 flex items-center justify-center gap-1.5">
                      <div className="w-1.5 h-1.5 rounded-full bg-foreground-400"></div>
                      <div className="w-1.5 h-1.5 rounded-full bg-foreground-400"></div>
                    </div>
                    <div className="p-3">
                      <div className="w-full h-32 rounded-lg bg-background-200 flex items-center justify-center mb-3">
                        <i className="ri-play-circle-line text-foreground-400 text-3xl"></i>
                      </div>
                      <div className="space-y-2">
                        <div className="h-2 bg-background-200 rounded w-3/4"></div>
                        <div className="h-2 bg-background-200 rounded w-1/2"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}